import { Outlet } from "react-router-dom";

import NotFoundPage from "@/pages/NotFoundPage";
import { type AllowedRoles, getStoredUserRoles, hasAnyRole } from "./routeAccess";

type RequireRoleProps = {
  roles: AllowedRoles;
};

/*
 * Layout route that renders its child routes only for users holding one of
 * `roles`. Anyone else gets the same Not Found page as an unknown URL, so a
 * restricted page is indistinguishable from one that doesn't exist. Children
 * are never rendered (so lazy pages are never loaded and their queries never
 * run) for a user without access. Must sit under RequireAuth, which sends
 * signed-out users to the login page.
 */
export default function RequireRole({ roles }: RequireRoleProps) {
  if (!hasAnyRole(getStoredUserRoles(), roles)) {
    return <NotFoundPage />;
  }

  return <Outlet />;
}
